<section class="message">
  <header class="header">
    <button class="back-btn" type="button" (click)="goBack()" aria-label="Volver">
      <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>
    </button>
    <div class="container">
      <div class="avatar-wrap">
        <img
          src="assets/images/irec_agente.jpg"
          [alt]="otherUser()?.fullName || 'Avatar de usuario'"
        />
        <span
          class="presence-dot"
          [class.presence-dot--online]="online()"
          [class.presence-dot--offline]="!online()"
          role="img"
          [attr.aria-label]="online() ? 'En línea' : 'Desconectado'"
        ></span>
      </div>
      <div class="message-details">
        <h2>{{ otherUser()?.fullName }}</h2>
        <p [class.is-typing]="typing()">{{ presenceLabel() }}</p>
      </div>
    </div>
    <div class="btns">
      <button type="button" class="refresh-chat" aria-label="Actualizar chat"
        title="Actualizar chat" [disabled]="refreshing() || chatLoading()" (click)="refreshChat()">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M20 11a8 8 0 1 1-2.3-5.7M20 4v5h-5"/></svg>
      </button>
      <button type="button" class="menu" aria-label="Menú" title="Próximamente" disabled>
        <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true"><circle cx="12" cy="5" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="12" cy="19" r="2"/></svg>
      </button>
    </div>
  </header>

  @if (connection() !== 'connected') {
        <div class="message-preview my-msg manual-validation-preview">
      class="connection-banner"
      [class.connection-banner--connecting]="connection() === 'connecting'"
      [class.connection-banner--offline]="connection() === 'disconnected'"
      role="status"
      aria-live="polite"
    >
      @if (connection() === 'connecting') {
        <span class="connection-banner__dot" aria-hidden="true"></span>
        <span>Conectando…</span>
      } @else {
        <svg class="connection-banner__icon" viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true"><path d="M12 2L1 21h22L12 2zm0 3.84L19.53 19H4.47L12 5.84zM11 10v4h2v-4h-2zm0 6v2h2v-2h-2z"/></svg>
        <span>Sin conexión. Reintentando…</span>
      }
    </div>
  }

  <div #listEl class="list list-messages">
    @if (chatLoading()) {
      <div class="day-separator" role="status">
        <span class="day-separator__pill">Cargando conversación…</span>
      </div>
    }
    @for (message of messages(); track message.id; let i = $index) {
      @if (shouldShowDaySeparator(i)) {
        <div class="day-separator" role="separator">
          <span class="day-separator__pill">{{ daySeparatorLabel(message.createdAt) }}</span>
        </div>
      }
      <div class="message-preview" [class.my-msg]="isMine(message.userId)" [class.friend-msg]="!isMine(message.userId)">
        <div
          class="msg"
          [class.msg--image]="isImage(message)"
          [class.msg--payment-result]="isPaymentResultMessage(message)"
          [class.msg--report-result]="isReportResult(message)"
        >
          @if (isImage(message)) {
            <div
              class="img-wrap"
              [class.img-wrap--payment-result]="isPaymentResultMessage(message)"
              [class.is-rejected]="badgeFor(message)?.tone === 'rejected'"
            >
              <img
                [src]="displayImageUrl(message)"
                class="msg-img"
                [class.msg-img--preview]="displayImageUrl(message) !== message.remoteMediaUrl"
                [class.msg-img--payment-result]="isPaymentResultMessage(message)"
                [alt]="message.caption || 'Imagen adjunta'"
                (click)="openImage(message)"
                (keydown)="onImageKeydown($event, message)"
                role="button"
                tabindex="0"
                (load)="requestScroll()"
              />
              @if (shouldPreloadRemoteImage(message)) {
                <img
                  [src]="message.remoteMediaUrl!"
                  class="msg-img-preload"
                  alt=""
                  aria-hidden="true"
                  (load)="markRemoteImageReady(message)"
                />
              }
              @if (isUploadingImage(message)) {
                <div class="upload-overlay" aria-hidden="true">
                  <span class="upload-spinner"></span>
                  <span class="upload-label">Subiendo…</span>
                </div>
              }
              @if (badgeFor(message); as badge) {
                <span class="validation-badge" [class]="badge.tone" [title]="badge.title">
                  {{ badge.label }}
                </span>
              }
              @if (message.caption) {
                <p class="caption">{{ message.caption }}</p>
              }
              @if (isPaymentResultMessage(message)) {
                <app-payment-result-message
                  [message]="message"
                  (manualValidationRequested)="showManualValidationForm($event)"
                />
              }
            </div>
          } @else if (isReportResult(message)) {
            <app-report-result-message [message]="message" />
          } @else {
            <p>{{ message.text }}</p>
            @if (isReportAction(message)) {
              <button type="button" class="report-action" [disabled]="!canOpenReport(message)"
                (click)="openReport(message)">Solicitar reporte</button>
            }
          }
          <div class="time">
            <small>{{ message.createdAt | date: 'h:mm a' }}</small>
            @if (showSingleCheck(message)) {
              <span
                class="receipt-status sent"
                aria-hidden="true"
                [attr.title]="receiptTitle(message)"
              >
                <svg viewBox="0 0 16 15" width="16" height="15">
                  <path
                    d="M3.8 7.9 6.2 10.2 12.3 4.1"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.7"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </span>
            }
            @if (showDoubleCheck(message)) {
              <span
                class="receipt-status double"
                [class.processing]="receiptStatusFor(message) === 'processing'"
                [class.done]="receiptStatusFor(message) === 'done'"
                aria-hidden="true"
                [attr.title]="receiptTitle(message)"
              >
                <svg viewBox="0 0 16 15" width="16" height="15">
                  <path
                    d="M1.9 7.9 4.3 10.2 10.4 4.1"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.7"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M5.7 7.9 8.1 10.2 14.2 4.1"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.7"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </span>
            }
            @if (receiptStatusFor(message) === 'failed') {
              <span
                class="receipt-status failed"
                aria-hidden="true"
                [attr.title]="receiptTitle(message)"
              >
                <svg viewBox="0 0 16 16" width="14" height="14">
                  <path fill="currentColor" d="M8 1.33a6.67 6.67 0 1 0 0 13.34A6.67 6.67 0 0 0 8 1.33Zm0 3a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 8 4.33Zm0 7.17a.92.92 0 1 1 0-1.84.92.92 0 0 1 0 1.84Z"></path>
                </svg>
              </span>
            }
          </div>
        </div>
      </div>
      @if (isManualValidationFormFor(message)) {
        <div #manualValidationFormRow class="message-preview my-msg manual-validation-preview">
          <div class="msg msg--manual-review">
            <app-payment-result-manual-review
              [message]="message"
              [formMode]="true"
            />
            <div class="time">
              <small>{{ manualValidationRequest()?.createdAt | date: 'h:mm a' }}</small>
            </div>
          </div>
        </div>
      }
    }
  </div>

  <section class="input-message">
    <div class="container">
      <div class="icons">
        <button
          type="button"
          class="attach"
          (click)="onAttachmentClick(fileInput)"
          [disabled]="refreshing() || chatLoading()"
          title="Adjuntar imagen"
          aria-label="Adjuntar imagen"
          [attr.aria-expanded]="attachmentMenuOpen()"
          aria-haspopup="menu"
        >
          <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor" aria-hidden="true"><path d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5a2.5 2.5 0 0 1 5 0v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5a2.5 2.5 0 0 0 5 0V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"/></svg>
        </button>
        @if (attachmentMenuOpen()) {
          <div class="attachment-menu" role="menu" aria-label="Opciones para adjuntar">
            <button type="button" role="menuitem" [disabled]="refreshing() || chatLoading()"
              (click)="openAttachmentInput(cameraInput)">
              <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true"><path d="M9 2 7.17 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-3.17L15 2H9Zm3 15a5 5 0 1 1 0-10 5 5 0 0 1 0 10Zm0-2.2a2.8 2.8 0 1 0 0-5.6 2.8 2.8 0 0 0 0 5.6Z"/></svg>
              <span>Tomar foto</span>
            </button>
            <button type="button" role="menuitem" [disabled]="refreshing() || chatLoading()"
              (click)="openAttachmentInput(fileInput)">
              <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true"><path d="M21 19V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2ZM8.5 11.5l2.5 3.01L14.5 10l4.5 6H5l3.5-4.5Z"/></svg>
              <span>Elegir imágenes</span>
            </button>
          </div>
        }
        <input
          #cameraInput
          id="cameraAttachmentInput"
          name="cameraAttachmentInput"
          type="file"
          accept="image/jpeg,image/png"
          capture="environment"
          aria-label="Tomar foto con la cámara"
          hidden
          [disabled]="refreshing() || chatLoading()"
          (change)="onFileSelected($event)"
        />
        <input
          #fileInput
          id="galleryAttachmentInput"
          name="galleryAttachmentInput"
          type="file"
          accept=".jpg,.jpeg,.png,image/jpeg,image/png"
          [multiple]="true"
          aria-label="Seleccionar imágenes desde el dispositivo"
          hidden
          [disabled]="refreshing() || chatLoading()"
          (change)="onFileSelected($event)"
        />
      </div>
      <input
        class="input"
        type="text"
        placeholder="Escribe un mensaje"
        aria-label="Escribe un mensaje"
        [disabled]="refreshing() || chatLoading()"
        [ngModel]="textMsg()"
        (ngModelChange)="textMsg.set($event)"
        (keyup.enter)="onSend()"
      />
      @if (!textMsg()) {
        <span class="voice-message" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"/></svg>
        </span>
      } @else {
        <button
          type="button"
          class="send-logo"
          (click)="onSend()"
          [disabled]="!canSend()"
          [attr.aria-disabled]="!canSend()"
          [title]="canSend() ? 'Enviar' : refreshing() || chatLoading() ? 'Chat en actualización' : 'Sin conexión'"
          aria-label="Enviar mensaje"
        >
          <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>
        </button>
      }
    </div>
  </section>

  @if (modalAction(); as action) {
    <app-report-submission-modal [action]="action" (closed)="closeReport()"
      (unavailable)="markReportUnavailable($event)"
      (refreshRequired)="markReportRefreshRequired($event)" />
  }
</section>
